import { render, staticRenderFns } from "./TukuAll.vue?vue&type=template&id=3c31bbc7&scoped=true&"
import script from "./TukuAll.vue?vue&type=script&lang=js&"
export * from "./TukuAll.vue?vue&type=script&lang=js&"
import style0 from "./TukuAll.vue?vue&type=style&index=0&id=3c31bbc7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31bbc7",
  null
  
)

export default component.exports